
let map_instance = null;

export const setMapInstance = map => map_instance = map;
export const getMapInstance = () => map_instance;


//////////////////////////////////////////////
//Input: Client object with "impact_details"//
//Output: url of icon image //////////////////
//////////////////////////////////////////////
export const getIconForClient = (client) => {

	try {
		if(!window.Store || !window.Store.getState().connection)
			throw Error("Application State with connection variable required.");

		var iconImg = "default-home-";
		var {baseUrl, imagesPath} = window.Store.getState().connection;
		var iconName = "icon";

		if(!client || !client.impact_details)
			return baseUrl + imagesPath + iconImg + iconName + '.png';

		//Thresholds for icon colors:
		var {hailSize} = client.impact_details;
		hailSize = String(hailSize).replace(' ','').replace('"','').replace('(Isolated)','').replace('(isolated)','').replace('isolated','');

		if(hailSize) {
			hailSize = Number(hailSize);
			if(hailSize <= 1.25) {
				//Quarter - Half Dollar
				iconName = "1";
			}
			else if(hailSize > 1.25 && hailSize < 1.75) {
				//Ping Pong Ball - Golf Ball
				iconName = "2";
			}
			else if(hailSize >= 1.75 && hailSize < 2.50)
			{
				//Golf Ball - Tennis Ball
				iconName = "3";
			}
			else if(hailSize >= 2.50) {
				// Tennis Ball+
				iconName = "4";
			}
		}
		return baseUrl + imagesPath + iconImg + iconName + '.png';

	}
	catch(e) {
		console.error(e);
	}
}

export function getPlacemarkNameForHailsize(hailSize) {
	var hailString = "";
		if(hailSize) {
			if(hailSize <= 1.25) {
				//Quarter - Half Dollar
				hailString = "Quarter - Half Dollar";
			}
			else if(hailSize > 1.25 && hailSize < 1.75) {
				//Ping Pong Ball - Golf Ball
				hailString = "Ping Pong Ball - Golf Ball";
			}
			else if(hailSize >= 1.75 && hailSize < 2.50)
			{
				//Golf Ball - Tennis Ball
				hailString = "Golf Ball - Tennis Ball";
			}
			else if(hailSize >= 2.50) {
				// Tennis Ball+
				hailString = "Tennis Ball+ ";
			}
		}
	return hailString;
}
///////////////////////////////////////
//Input google address components./////
//Returns standard address component.//
///////////////////////////////////////

export const parseAddress = (address) => {
	var {
		address_components,
		geometry,
		place_id,
		formatted_address,
		place_id
	} = address;
	var geocoded = true;

	if(typeof address !== 'object')
		throw new Error("Input must be an object. (Google address)");
	var city = "";
	var state = "";
	var street = ""; //Street is house number + street name.
	var county = "";
	var country = "";
	var street_number = "";
	var route = "";
	var zip = ""
	if(address_components) {
		address_components.forEach((component) => {
			var type = component.types[0];
			var long_name = component.long_name;
			var short_name = component.short_name;
			switch(type) {
				case 'postal_code':
					zip = long_name;
					break;
				case 'street_number':
					street += long_name;
					street_number = long_name;
					break;
				case 'route':
					if(street.length > 0)
						street += ' ';
					street += long_name;
					route = long_name
					break;
				case 'locality':
					city = long_name;
					break;
				case 'administrative_area_level_1': //State
					state = short_name;
					break;
				case 'administrative_area_level_2': //County
					county = long_name;
					break;
				case 'country':
					country = long_name;
					break;
			}
		});
	}

	var address_object = {
		street,
		street_number,
		route,
		city,
		state,
		county,
		country,
		zip,
		formatted_address,
		geocoded,
		feature : {
			type : "Feature" ,
			geometry : {
				type : "Point",
				coordinates : [geometry.location.lng(),geometry.location.lat()]
			}
		}
	}
	return address_object;
}

export const parseColeAddress = (address) => {
	const {
		route: street_name,
		street_number: house_number,
		zip,
		state
	} = parseAddress(address);

	return { street_name, house_number, zip, state };
}

//License for the GeoJSON function:

// Copyright (c) 2012, Jason Sanford
// All rights reserved.

// Redistribution and use in source and binary forms, with or without modification, are
// permitted provided that the following conditions are met:

//     1. Redistributions of source code must retain the above copyright notice, this list of
//        conditions and the following disclaimer.

//     2. Redistributions in binary form must reproduce the above copyright notice, this list
//        of conditions and the following disclaimer in the documentation and/or other materials
//        provided with the distribution.

// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
// COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
// SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
// HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR
// TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
// SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

//End Liscense for the GeoJSON function
export const GeoJSON = function( geojson, options ){

	var _geometryToGoogleMaps = function( geojsonGeometry, options, geojsonProperties ){

		var googleObj, opts = _copy(options);

		switch ( geojsonGeometry.type ){
			case "Point":
				opts.position = new maps.LatLng(geojsonGeometry.coordinates[1], geojsonGeometry.coordinates[0]);
				googleObj = new maps.Marker(opts);
				if (geojsonProperties) {
					googleObj.set("geojsonProperties", geojsonProperties);
				}
				break;

			case "MultiPoint":
				googleObj = [];
				for (var i = 0; i < geojsonGeometry.coordinates.length; i++){
					opts.position = new maps.LatLng(geojsonGeometry.coordinates[i][1], geojsonGeometry.coordinates[i][0]);
					googleObj.push(new maps.Marker(opts));
				}
				if (geojsonProperties) {
					for (var k = 0; k < googleObj.length; k++){
						googleObj[k].set("geojsonProperties", geojsonProperties);
					}
				}
				break;

			case "LineString":
				var path = [];
				for (var i = 0; i < geojsonGeometry.coordinates.length; i++){
					var coord = geojsonGeometry.coordinates[i];
					var ll = new maps.LatLng(coord[1], coord[0]);
					path.push(ll);
				}
				opts.path = path;
				googleObj = new maps.Polyline(opts);
				if (geojsonProperties) {
					googleObj.set("geojsonProperties", geojsonProperties);
				}
				break;

			case "MultiLineString":
				googleObj = [];
				for (var i = 0; i < geojsonGeometry.coordinates.length; i++){
					var path = [];
					for (var j = 0; j < geojsonGeometry.coordinates[i].length; j++){
						var coord = geojsonGeometry.coordinates[i][j];
						var ll = new maps.LatLng(coord[1], coord[0]);
						path.push(ll);
					}
					opts.path = path;
					googleObj.push(new maps.Polyline(opts));
				}
				if (geojsonProperties) {
					for (var k = 0; k < googleObj.length; k++){
						googleObj[k].set("geojsonProperties", geojsonProperties);
					}
				}
				break;

			case "Polygon":
				var paths = [];
				var exteriorDirection;
				var interiorDirection;
				for (var i = 0; i < geojsonGeometry.coordinates.length; i++){
					var path = [];
					for (var j = 0; j < geojsonGeometry.coordinates[i].length; j++){
						var ll = new maps.LatLng(geojsonGeometry.coordinates[i][j][1], geojsonGeometry.coordinates[i][j][0]);
						path.push(ll);
					}
					if(!i){
						exteriorDirection = _ccw(path);
						paths.push(path);
					}else if(i == 1){
						interiorDirection = _ccw(path);
						if(exteriorDirection == interiorDirection){
							paths.push(path.reverse());
						}else{
							paths.push(path);
						}
					}else{
						if(exteriorDirection == interiorDirection){
							paths.push(path.reverse());
						}else{
							paths.push(path);
						}
					}
				}
				opts.paths = paths;
				googleObj = new maps.Polygon(opts);
				if (geojsonProperties) {
					googleObj.set("geojsonProperties", geojsonProperties);
				}
				break;

			case "MultiPolygon":
				googleObj = [];
				for (var i = 0; i < geojsonGeometry.coordinates.length; i++){
					var paths = [];
					var exteriorDirection;
					var interiorDirection;
					for (var j = 0; j < geojsonGeometry.coordinates[i].length; j++){
						var path = [];
						for (var k = 0; k < geojsonGeometry.coordinates[i][j].length; k++){
							var ll = new maps.LatLng(geojsonGeometry.coordinates[i][j][k][1], geojsonGeometry.coordinates[i][j][k][0]);
							path.push(ll);
						}
						if(!j){
							exteriorDirection = _ccw(path);
							paths.push(path);
						}else if(j == 1){
							interiorDirection = _ccw(path);
							if(exteriorDirection == interiorDirection){
								paths.push(path.reverse());
							}else{
								paths.push(path);
							}
						}else{
							if(exteriorDirection == interiorDirection){
								paths.push(path.reverse());
							}else{
								paths.push(path);
							}
						}
					}
					opts.paths = paths;
					googleObj.push(new maps.Polygon(opts));
				}
				if (geojsonProperties) {
					for (var k = 0; k < googleObj.length; k++){
						googleObj[k].set("geojsonProperties", geojsonProperties);
					}
				}
				break;

			case "GeometryCollection":
				googleObj = [];
				if (!geojsonGeometry.geometries){
					googleObj = _error("Invalid GeoJSON object: GeometryCollection object missing \"geometries\" member.");
				}else{
					for (var i = 0; i < geojsonGeometry.geometries.length; i++){
						googleObj.push(_geometryToGoogleMaps(geojsonGeometry.geometries[i], opts, geojsonProperties || null));
					}
				}
				break;

			default:
				googleObj = _error("Invalid GeoJSON object: Geometry object must be one of \"Point\", \"LineString\", \"Polygon\" or \"MultiPolygon\".");
		}

		return googleObj;

	};

	var _error = function( message ){

		return {
			type: "Error",
			message: message
		};

	};

	var _ccw = function( path ){
		var isCCW;
		var a = 0;
		for (var i = 0; i < path.length-2; i++){
			a += ((path[i+1].lat() - path[i].lat()) * (path[i+2].lng() - path[i].lng()) - (path[i+2].lat() - path[i].lat()) * (path[i+1].lng() - path[i].lng()));
		}
		if(a > 0){
			isCCW = true;
		}
		else{
			isCCW = false;
		}
		return isCCW;
	};

  var _copy = function(obj){
    var newObj = {};
    for(var i in obj){
      if(obj.hasOwnProperty(i)){
        newObj[i] = obj[i];
      }
    }
    return newObj;
  };

	var obj;

	var opts = options || {};

	switch ( geojson.type ){

		case "FeatureCollection":
			if (!geojson.features){
				obj = _error("Invalid GeoJSON object: FeatureCollection object missing \"features\" member.");
			}else{
				obj = [];
				for (var i = 0; i < geojson.features.length; i++){
					obj.push(_geometryToGoogleMaps(geojson.features[i].geometry, opts, geojson.features[i].properties));
				}
			}
			break;

		case "GeometryCollection":
			if (!geojson.geometries){
				obj = _error("Invalid GeoJSON object: GeometryCollection object missing \"geometries\" member.");
			}else{
				obj = [];
				for (var i = 0; i < geojson.geometries.length; i++){
					obj.push(_geometryToGoogleMaps(geojson.geometries[i], opts));
				}
			}
			break;

		case "Feature":
			if (!( geojson.properties && geojson.geometry )){
				obj = _error("Invalid GeoJSON object: Feature object missing \"properties\" or \"geometry\" member.");
			}else{
				obj = _geometryToGoogleMaps(geojson.geometry, opts, geojson.properties);
			}
			break;

		case "Point": case "MultiPoint": case "LineString": case "MultiLineString": case "Polygon": case "MultiPolygon":
			obj = geojson.coordinates
				? obj = _geometryToGoogleMaps(geojson, opts)
				: _error("Invalid GeoJSON object: Geometry object missing \"coordinates\" member.");
			break;

		default:
			obj = _error("Invalid GeoJSON object: GeoJSON object must be one of \"Point\", \"LineString\", \"Polygon\", \"MultiPolygon\", \"Feature\", \"FeatureCollection\" or \"GeometryCollection\".");

	}

	return obj;

};

  /**
   * Process each point in a Geometry, regardless of how deep the points may lie.
   * @param {google.maps.Data.Geometry} geometry The structure to process
   * @param {function(google.maps.LatLng)} callback A function to call on each
   *     LatLng point encountered (e.g. Array.push)
   * @param {Object} thisArg The value of 'this' as provided to 'callback' (e.g.
   *     myArray)
   */
export const processPoints = (geometry, callback, thisArg) => {
    if (geometry instanceof google.maps.LatLng) {
      callback.call(thisArg, geometry);
    } else if (geometry instanceof google.maps.Data.Point) {
      callback.call(thisArg, geometry.get());
    } else {
      geometry.getArray().forEach(function(g) {
        processPoints(g, callback, thisArg);
      });
    }
}

// export const processGeoJsonPoints = (coordinates, callback, thisArg) => {
// 	var processArray = (array) => {

// 	}

// 	if(coordinates.constructor.name === 'Array' && coordinates[0].constructor.name !== "Array") {
// 		callback.call(thisArg, )
// 	}
// }



// WEBPACK FOOTER //
// ./src/common/utils/google_maps.js